export default __webpack_public_path__ + "static/media/milap.3cc5ba56.png";